import React from "react";
import { Typography, Box, Button } from "@mui/material";
import { useHistory, useParams } from "react-router-dom";

import { Driver } from "types";
import { granite, moovsBlue } from "globals/design-system/colors";
import theme from "globals/design-system/theme";
import { CircleAvatar } from "components/ui";
import { CalendarIcon } from "globals/design-system/icons";
import { useLaunchDarklyFlags } from "globals/hooks/useLaunchDarklyFlags";

type DriverHeaderProps = {
  driver: Driver;
};

function DriverHeader(props: DriverHeaderProps) {
  const { driver } = props;
  const history = useHistory();
  const { driverId } = useParams<{ driverId: string }>();
  const { enableDriverAvailability } = useLaunchDarklyFlags();

  const handleAvailabilityClick = () => {
    history.push(`/driver/${driverId}/availability`);
  };

  return (
    <>
      {/* Mobile Header */}
      <Box
        display={{ xs: "flex", md: "none" }}
        flexDirection="column"
        alignItems="center"
        bgcolor={theme.palette.background.paper}
        py={2}
        px={2}
        gap={1.5}
      >
        <Box display="flex" alignItems="center">
          <CircleAvatar
            alt="driver"
            size="medium"
            placeholder={[driver.firstName, driver.lastName]}
            src={driver?.driverProfilePhoto}
          />
          <Typography
            style={{ marginLeft: 8, letterSpacing: "-0.25px", color: granite }}
          >{`${driver.firstName} ${driver.lastName}`}</Typography>
        </Box>

        {enableDriverAvailability && (
          <Button
            variant="outlined"
            size="small"
            startIcon={<CalendarIcon color={moovsBlue} />}
            onClick={handleAvailabilityClick}
            sx={{
              borderColor: moovsBlue,
              color: moovsBlue,
              textTransform: "none",
              fontWeight: 500,
              fontSize: "14px",
              padding: "6px 16px",
              "&:hover": {
                borderColor: moovsBlue,
                bgcolor: `${moovsBlue}0A`,
              },
            }}
          >
            My Availability
          </Button>
        )}
      </Box>

      {/* Desktop Header */}
      <Box
        display={{ xs: "none", md: "flex" }}
        flexDirection="row"
        height="60px"
        alignItems="center"
        justifyContent="center"
        bgcolor={theme.palette.background.paper}
        px={2}
        position="relative"
      >
        <Box display="flex" alignItems="center">
          <CircleAvatar
            alt="driver"
            size="medium"
            placeholder={[driver.firstName, driver.lastName]}
            src={driver?.driverProfilePhoto}
          />
          <Typography
            style={{ marginLeft: 8, letterSpacing: "-0.25px", color: granite }}
          >{`${driver.firstName} ${driver.lastName}`}</Typography>
        </Box>

        {enableDriverAvailability && (
          <Box position="absolute" right={16}>
            <Button
              variant="outlined"
              size="small"
              startIcon={<CalendarIcon color={moovsBlue} />}
              onClick={handleAvailabilityClick}
              sx={{
                borderColor: moovsBlue,
                color: moovsBlue,
                textTransform: "none",
                fontWeight: 500,
                fontSize: "14px",
                padding: "6px 16px",
                "&:hover": {
                  borderColor: moovsBlue,
                  bgcolor: `${moovsBlue}0A`,
                },
              }}
            >
              My Availability
            </Button>
          </Box>
        )}
      </Box>
    </>
  );
}

export default DriverHeader;
